import {
    CheckIcon,
    DownloadCircleFilled,
    DownloadOutlined,
} from '@landr/maestro';
import { t } from '@lingui/macro';
import { DownloadableItem, Sample, DownloadableItemSource } from 'types';
import { DownloadType } from 'types/enums';
import { isSample } from 'helpers/isSample';

export const getDownloadIcon = (
    isDownloaded: boolean,
    isDAWPlugin: boolean,
) => {
    if (isDAWPlugin) {
        return isDownloaded ? CheckIcon : DownloadOutlined;
    } else {
        return isDownloaded ? DownloadCircleFilled : DownloadOutlined;
    }
};

export const getDownloadLabel = (
    item: DownloadableItemSource,
    downloadableItem: DownloadableItem,
    isDAWPlugin: boolean,
    label: string,
) => {
    if (isDAWPlugin) {
        if (downloadableItem.isDownloaded) {
            return t`Added to downloads`;
        } else {
            const isFree = isSample(item) && item?.credits === 0;

            return isFree ? t`Add to downloads` : t`Buy and add to downloads`;
        }
    } else {
        const credits = item && (item as Sample)?.credits;

        const dynamicLabel =
            downloadableItem.type === DownloadType.Sample &&
            !downloadableItem.isDownloaded &&
            credits
                ? t`Download - ${credits} credit`
                : label;

        return dynamicLabel;
    }
};
